import './LivekiPage.scss';
import './JoinRoomPage.scss';
import { useForm } from 'react-hook-form';
import { useParams } from 'react-router-dom';
import Loading from '../components/Loading';
import { useState } from 'react';
import { checkActiveVideoSpace, generatePublicLiveKitVideoSpaceToken } from '../services/videoManagementService';

export interface JoinRoomForm {
  username: string;
}

export function JoinVideoSpacePage() {
  const { roomName } = useParams();
  const [showLoading, setShowLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const {
    register,
    formState: { errors },
    handleSubmit,
  } = useForm({
    defaultValues: {
      username: '',
    },
  });

  const onSubmit = (data: JoinRoomForm) => {
    if (roomName && data?.username) {
      setShowLoading(true);
      checkActiveVideoSpace(roomName)
        .then((active: boolean) => {
          if (active) {
            generatePublicLiveKitVideoSpaceToken(data.username, getIdentity(data.username), roomName)
              .then((token: string | null) => {
                if (token) {
                  window.location.replace(window.location.origin + '/vs?token=' + token);
                }
              })
              .finally(() => {
                setShowLoading(false);
              });
          } else {
            setError('The video space is not active.');
            setShowLoading(false);
          }
        })
        .catch(() => {
          setError('An error occurred.');
          setShowLoading(false);
        });
    }
  };

  const getIdentity = (value: string): string => {
    if (!value) {
      return Date.now().toString();
    }
    return value.trim().replaceAll(' ', '_') + '_' + Date.now().toString();
  };

  return (
    <main data-lk-theme="default">
      {showLoading && <Loading />}
      <div id="JoinRoomPage" className="wrapper">
        <div className="lk-prejoin">
          {/*<span className='title'>Room: {roomName}</span>*/}
          <div className="lk-video-container">
            <div className="lk-camera-off-note">
              <svg
                width="320"
                height="320"
                viewBox="0 0 320 320"
                preserveAspectRatio="xMidYMid meet"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M160 180C204.182 180 240 144.183 240 100C240 55.8172 204.182 20 160 20C115.817 20 79.9997 55.8172 79.9997 100C79.9997 144.183 115.817 180 160 180Z"
                  fill="white"
                  fillOpacity="0.25"
                ></path>
                <path
                  d="M97.6542 194.614C103.267 191.818 109.841 192.481 115.519 195.141C129.025 201.466 144.1 205 159.999 205C175.899 205 190.973 201.466 204.48 195.141C210.158 192.481 216.732 191.818 222.345 194.614C262.703 214.719 291.985 253.736 298.591 300.062C300.15 310.997 291.045 320 280 320H39.9997C28.954 320 19.8495 310.997 21.4087 300.062C28.014 253.736 57.2966 214.72 97.6542 194.614Z"
                  fill="white"
                  fillOpacity="0.25"
                ></path>
              </svg>
            </div>
          </div>
          <form className="lk-username-container" onSubmit={handleSubmit(onSubmit)}>
            <input
              className="lk-form-control"
              {...register('username', { required: true, pattern: /^[\u00C0-\u02AFA-z0-9 ]+$/ })}
              type="text"
              placeholder="Username"
              autoComplete="off" /*aria-invalid={errors.username ? "true" : "false"}*/
            />
            {errors.username?.type === 'pattern' && (
              <div className="lk-form-control-error">Invalid format. Use only letters, numbers and "_".</div>
            )}
            {error && <div className="lk-form-control-error">{error}</div>}
            <button className="lk-button lk-join-button" type="submit" disabled={errors.username?.type === 'required'}>
              Join Room
            </button>
          </form>
        </div>
      </div>
    </main>
  );
}

export default JoinVideoSpacePage;
